import { styled, Typography } from "~/common/mui";
import type ComponentTypes from "~/features/cms/componentTypes";
import classNames from "classnames";
import { resolveUrl } from "~/utils/url/urlResolver";

export interface CMSSimpleBannerMediaDTO {
  code?: string;
  url?: string;
  altText?: string;
}

export interface CMSSimpleBannerProps {
  type: ComponentTypes.CMSSimpleBanner;
  id: string;
  className?: string;
  urlLink?: string;
  media?: CMSSimpleBannerMediaDTO;
  headline?: string;
  content?: string;
}

export const CMSSimpleBanner = ({ urlLink, media, headline, content, className }: CMSSimpleBannerProps) => {
  const imageUrl = media?.url;

  if (!imageUrl) {
    return null;
  }

  const altText = media?.altText ?? headline ?? "";

  const picture = (
    <Root className={classNames("scha__cms", className)}>
      <BannerImage src={resolveUrl(imageUrl)} alt={altText} loading="lazy" />
      {(headline || content) && (
        <Overlay>
          {headline && (
            <Typography variant="headlineMedium" component="p">
              {headline}
            </Typography>
          )}
          {content && <Typography variant="bodyMedium">{content}</Typography>}
        </Overlay>
      )}
    </Root>
  );

  if (!urlLink) {
    return picture;
  }

  return (
    <BannerLink href={resolveUrl(urlLink)} className={classNames("scha__cms", className)}>
      <BannerImage src={resolveUrl(imageUrl)} alt={altText} loading="lazy" />
      {(headline || content) && (
        <Overlay>
          {headline && (
            <Typography variant="headlineMedium" component="p">
              {headline}
            </Typography>
          )}
          {content && <Typography variant="bodyMedium">{content}</Typography>}
        </Overlay>
      )}
    </BannerLink>
  );
};

const Root = styled("div")({ display: "block", width: "100%" });

const BannerImage = styled("img")({
  display: "block",
  width: "100%",
  height: "auto",
  maxWidth: "100%",
});

const BannerLink = styled("a")({ display: "block", width: "100%" });

const Overlay = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
